import type { ReactNode } from 'react';
import './muster.css';

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * LEERZUSTAND (Auftrag 17.09.2026, Abschnitt 20)
 * ═══════════════════════════════════════════════════════════════════════════
 *
 *   „Nicht ‚Keine Daten', sondern erklärend mit Handlungsangebot
 *    ([Filter zurücksetzen], [Berechnung starten])."
 *
 * Ein leerer Bereich beantwortet immer dieselben drei Fragen, und deshalb
 * hat dieses Muster genau drei Felder:
 *   `titel`      - WAS ist leer
 *   `erklaerung` - WARUM ist es leer (woher kämen die Daten)
 *   `aktion`     - WAS kann ich jetzt tun
 *
 * `titel` ist Pflicht, `erklaerung` und `aktion` sind es nicht - es gibt
 * Stellen, an denen es nichts zu tun gibt. Ein Leerzustand ohne jede
 * Erklärung ist aber fast immer ein Zeichen dafür, dass der Entwickler die
 * Herkunft der Daten selbst nicht kennt.
 */

export interface EmptyStateProps {
  titel: string;
  erklaerung?: ReactNode;
  /** Ein oder zwei Knöpfe - der erste ist das Handlungsangebot. */
  aktion?: ReactNode;
  /** Sinnbild aus `Icons.tsx`; bewusst optional und zurückhaltend. */
  icon?: ReactNode;
  /** Gedrängte Ausführung, z. B. innerhalb einer Tabelle. */
  klein?: boolean;
  className?: string;
}

export function EmptyState({
  titel, erklaerung, aktion, icon, klein, className,
}: EmptyStateProps) {
  const klassen = ['m-leerzustand'];
  if (klein) klassen.push('m-leerzustand-klein');
  if (className) klassen.push(className);

  return (
    <div className={klassen.join(' ')} role="status">
      {icon && <div className="m-leerzustand-icon" aria-hidden="true">{icon}</div>}
      <p className="m-leerzustand-titel">{titel}</p>
      {erklaerung && <div className="m-leerzustand-text">{erklaerung}</div>}
      {aktion && <div className="m-leerzustand-aktion">{aktion}</div>}
    </div>
  );
}
